import { metalSwatch } from './metal-swatch.mjs';

/** Keep native selects as the POST contract and no-JS fallback. Enhance with labelled radios. */
export const enhanceOfferChoices = (root, assets, selector = '[data-offer-attribute]') => {
    const fields = [...root.querySelectorAll(selector)].map((select) => {
        const native = select.closest('label');
        const group = document.createElement('fieldset'); group.className = 'OvOfferChoices';
        const legend = document.createElement('legend');
        legend.textContent = native.childNodes[0].textContent.trim();
        const selectedLabel = document.createElement('span'); selectedLabel.className = 'OvOfferChoices__selected';
        legend.append(selectedLabel);
        const options = document.createElement('div'); options.className = 'OvOfferChoices__options';
        const values = [...select.options].filter((option) => option.value);
        if (/rozmiar|dlugosc/.test(select.name)) values.sort((a, b) => a.textContent.localeCompare(b.textContent, undefined, { numeric: true }));
        const inputs = values.map((option, index) => {
            const label = document.createElement('label'); label.className = 'OvOfferChoices__choice';
            const input = document.createElement('input');
            Object.assign(input, {
                type: 'radio', name: `choice-${select.id}`,
                id: `${select.id}-choice-${index}`, value: option.value, className: 'OvOfferChoices__input',
            });
            const content = document.createElement('span'); content.className = 'OvOfferChoices__label';
            const swatch = /metal/.test(select.name) ? metalSwatch(option.value) : null;
            if (swatch) {
                const image = document.createElement('img');
                Object.assign(image, { src: `${assets}product/metal-${swatch}.svg`, alt: '', width: 24, height: 24 });
                content.append(image); label.classList.add('OvOfferChoices__choice--metal');
                label.title = option.textContent;
            }
            const text = document.createElement('span'); text.className = 'OvOfferChoices__name'; text.textContent = option.textContent; content.append(text);
            input.addEventListener('change', (event) => {
                event.stopPropagation(); select.value = input.value;
                select.dispatchEvent(new Event('change', { bubbles: true }));
            });
            label.append(input, content); options.append(label);
            return { input, option };
        });
        group.append(legend, options); native.after(group); native.hidden = true;
        // Hidden native controls cannot receive validation focus; the submit handler focuses a chip.
        select.required = false;
        return { select, inputs, selectedLabel };
    });
    return {
        sync: () => fields.forEach(({ select, inputs, selectedLabel }) => {
            const selected = inputs.find(({ input }) => input.value === select.value);
            selectedLabel.textContent = selected ? ` · ${selected.option.textContent}` : '';
            inputs.forEach(({ input, option }) => {
                input.checked = select.value === input.value;
                input.disabled = select.disabled || option.disabled;
            });
        }),
        setError: (messageId) => fields.forEach(({ select, inputs }) => inputs.forEach(({ input }) => {
            if (messageId && !select.disabled && !select.value) {
                input.setAttribute('aria-invalid', 'true'); input.setAttribute('aria-describedby', messageId);
            } else {
                input.removeAttribute('aria-invalid'); input.removeAttribute('aria-describedby');
            }
        })),
        focusMissing: () => fields.find(({ select }) => !select.value)?.inputs.find(({ input }) => !input.disabled)?.input.focus(),
    };
};
